import {useCallback} from "react";

export const useCookies = () => {
  const setCookie = useCallback(({name, value, expDays = 999, path = "", domain = ""}) => {
    if (!name) return console.error("No name provided for cookie");
    if (!value) return console.error("No value provided for cookie");

    let pathOption, domainOption;
    let expires = "expires=0;";
    if (expDays !== 0) {
      const d = new Date();
      d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
      expires = `expires=${d.toUTCString()};`;
    }

    if (path) {
      pathOption = `path=${path};`;
    } else {
      pathOption = "path=/;";
    }

    if (domain) {
      domainOption = `domain=${domain};`;
    } else {
      domainOption = "domain=forthwithlife.co.uk;";
    }

    document.cookie = `${name}=${value}; ${expires} ${pathOption} ${domainOption}`;
  }, []);

  const getCookie = useCallback(({cookieName}) => {
    const cookieArray = document.cookie.split(";");

    for (let i = 0; i < cookieArray.length; i++) {
      const cookie = cookieArray[i].split("=");

      if (cookieName == cookie[0].trim()) {
        return decodeURIComponent(cookie[1]);
      }
    }
  }, []);

  const deleteCookie = useCallback(({cookieName, path = "", domain = "forthwithlife.co.uk"}) => {
    if (path) {
      path = `path=${path};`;
    }

    if (domain) {
      domain = `domain=${domain};`;
    }

    document.cookie = `${cookieName}=; ${path} ${domain} max-age=0`;
  }, []);

  return {setCookie, getCookie, deleteCookie};
};
